<div class="projectable-form-wrapper api-session-form-wrapper"
  (keyup.enter)="save($event)"
  (keyup.escape)="closeModal(false)"
  >
  <lib-form-header
    [data]="formData"
    [title]="'API Session Details'"
    [moreActions]="moreActions"
    (actionRequested)="headerActionRequested($event)"
    [(formView)]="formView"
    [showHeaderButton]="false"
  ></lib-form-header>
  <div class="edge-router-form-container projectable-form-container">
    @if (formView === 'simple') {
      <div class="projectable-form-main-column form-group-row">
        <div class="form-group-column">
          <lib-form-field-container [showHeader]="false">
            <div class="form-field-label-container">
              <div class="form-field-title-container">
                <span class="form-field-title">ID</span>
              </div>
              <div class="config-container">
                <span>{{formData.id}}</span>
              </div>
            </div>
            <div class="form-field-label-container">
              <div class="form-field-title-container">
                <span class="form-field-title">Identity Name</span>
              </div>
              <a class="form-field-link" [href]="'./services/' + formData.identity.id" (click)="identityNameLinkClicked($event)">
                <div class="config-container config-container-clickable">
                  <span>{{formData.identity.name}}</span>
                </div>
              </a>
            </div>
            <div class="form-field-label-container">
              <div class="form-field-title-container">
                <span class="form-field-title">IP Address</span>
              </div>
              <div class="config-container">
                <span>{{formData.ipAddress}}</span>
              </div>
            </div>
            <div class="form-field-label-container">
              <div class="form-field-title-container">
                <span class="form-field-title">Created At</span>
              </div>
              <div class="config-container">
                <span>{{moment(formData.createdAt).format("M/D/YYYY h:mm A")}}</span>
              </div>
            </div>
            <div class="form-field-label-container">
              <div class="form-field-title-container">
                <span class="form-field-title">Updated At</span>
              </div>
              <div class="config-container">
                <span>{{moment(formData.updatedAt).format("M/D/YYYY h:mm A")}}</span>
              </div>
            </div>
            <div class="form-field-label-container">
              <div class="form-field-title-container">
                <span class="form-field-title">Last Activity</span>
              </div>
              <div class="config-container">
                <span>{{moment(formData.lastActivity).format("M/D/YYYY h:mm A")}}</span>
              </div>
            </div>
          </lib-form-field-container>
          <ng-content select="[slot=column-1-slot-1]"></ng-content>
        </div>
      </div>
    }
    @if (formView === 'raw') {
      <div class="form-group-column">
        @if (formData) {
          <lib-json-view [(data)]="formData"></lib-json-view>
        }
      </div>
    }
  </div>
</div>
@if (isLoading) {
  <lib-loading-indicator [isLoading]="isLoading"></lib-loading-indicator>
}
